import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { mockStories, Story } from '../data/mockData';
import { StoryPreviewModal } from '../components/StoryPreviewModal';
import { AdvancedSearchModal } from '../components/AdvancedSearchModal';
import { RepublishOptionsModal } from '../components/RepublishOptionsModal';
import { DownloadContentModal } from '../components/DownloadContentModal';
export function Explore() {
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get('search') || '');
  const [languageFilter, setLanguageFilter] = useState('all');
  const [brandFilter, setBrandFilter] = useState(searchParams.get('brand') || 'all');
  const [dateFilter, setDateFilter] = useState('all');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [regionFilter, setRegionFilter] = useState('all');
  const [filteredStories, setFilteredStories] = useState<Story[]>(mockStories);
  const [selectedStory, setSelectedStory] = useState<Story | null>(null);
  const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState(false);
  const [republishOptionsStory, setRepublishOptionsStory] = useState<Story | null>(null);
  const [downloadContentStory, setDownloadContentStory] = useState<Story | null>(null);
  useEffect(() => {
    const search = searchParams.get('search');
    const brand = searchParams.get('brand');
    if (search) {
      setSearchQuery(search);
    }
    if (brand) {
      setBrandFilter(brand);
    }
  }, [searchParams]);
  useEffect(() => {
    let filtered = mockStories;
    if (searchQuery) {
      filtered = filtered.filter(story => story.title.toLowerCase().includes(searchQuery.toLowerCase()) || story.content.toLowerCase().includes(searchQuery.toLowerCase()) || story.category.toLowerCase().includes(searchQuery.toLowerCase()));
    }
    if (languageFilter !== 'all') {
      filtered = filtered.filter(story => story.language === languageFilter);
    }
    if (brandFilter !== 'all') {
      filtered = filtered.filter(story => story.brand === brandFilter);
    }
    if (categoryFilter !== 'all') {
      filtered = filtered.filter(story => story.category === categoryFilter);
    }
    if (dateFilter !== 'all') {
      const today = new Date();
      filtered = filtered.filter(story => {
        const storyDate = new Date(story.date);
        const diffDays = Math.floor((today.getTime() - storyDate.getTime()) / (1000 * 60 * 60 * 24));
        if (dateFilter === 'today') return diffDays === 0;
        if (dateFilter === 'week') return diffDays <= 7;
        if (dateFilter === 'month') return diffDays <= 30;
        return true;
      });
    }
    setFilteredStories(filtered);
  }, [searchQuery, languageFilter, brandFilter, dateFilter, categoryFilter, regionFilter]);
  const handleRepublish = (story: Story) => {
    setRepublishOptionsStory(story);
  };
  const handleSelectApi = () => {
    if (republishOptionsStory) {
      alert(`Story "${republishOptionsStory.title}" has been republished through API!`);
      setRepublishOptionsStory(null);
    }
  };
  const handleSelectDownload = () => {
    if (republishOptionsStory) {
      setDownloadContentStory(republishOptionsStory);
      setRepublishOptionsStory(null);
    }
  };
  const handleClearAllFilters = () => {
    setSearchQuery('');
    setLanguageFilter('all');
    setBrandFilter('all');
    setDateFilter('all');
    setCategoryFilter('all');
    setRegionFilter('all');
  };
  const handleApplyFilters = () => {
    // Filters are already applied through useEffect
  };
  return <div className="space-y-6" data-id="element-203">
      {/* Header */}
      <div className="rounded-2xl p-8 text-white shadow-card-lg" style={{
      background: 'linear-gradient(135deg, #1e3a52 0%, #182941 50%, #12202f 100%)'
    }} data-id="element-204">
        <h1 className="text-4xl font-bold text-display mb-2 !text-white" data-id="element-205">
          Explore Stories
        </h1>
        <p className="text-lg text-white" data-id="element-206">
          Discover and republish content from the INN network
        </p>
      </div>
      {/* Search Bar */}
      <div className="bg-white rounded-xl p-6 shadow-card border border-neutral-200" data-id="element-207">
        <div className="flex items-center gap-4" data-id="element-208">
          <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Stories" className="flex-1 px-6 py-4 border border-neutral-300 rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all" data-id="element-209" />
          <button onClick={() => setIsAdvancedSearchOpen(true)} className="px-8 py-4 border-2 rounded-lg hover:bg-opacity-10 transition-all font-medium text-lg" style={{
          borderColor: '#0289BB',
          color: '#0289BB',
          backgroundColor: 'transparent'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.1)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} data-id="element-210">
            Advanced Search
          </button>
          <button className="px-8 py-4 text-white rounded-lg hover:shadow-md transition-all font-medium text-lg" style={{
          background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
        }} data-id="element-211">
            Find Stories
          </button>
        </div>
      </div>
      {/* Results Count */}
      <div className="flex items-center justify-between" data-id="element-212">
        <p className="text-sm text-neutral-600" data-id="element-213">
          <span className="font-semibold" style={{
          color: '#0289BB'
        }} data-id="element-214">
            {filteredStories.length}
          </span>{' '}
          stories found
        </p>
      </div>
      {/* Stories List */}
      <div className="space-y-4" data-id="element-215">
        {filteredStories.length === 0 ? <div className="bg-white rounded-xl p-12 shadow-card border border-neutral-200 text-center" data-id="element-216">
            <p className="text-neutral-500 text-lg" data-id="element-217">
              No stories found matching your criteria.
            </p>
          </div> : filteredStories.map(story => <div key={story.id} className="bg-white rounded-xl p-6 shadow-card hover:shadow-card-hover transition-all border border-neutral-200" data-id="element-218">
              <div className="flex items-start gap-6" data-id="element-219">
                <div className="flex-1 min-w-0" data-id="element-220">
                  <div className="flex items-start gap-3 mb-3" data-id="element-221">
                    <span className="inline-block px-3 py-1 text-white rounded-full text-xs font-semibold shadow-sm" style={{
                background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
              }} data-id="element-222">
                      {story.category}
                    </span>
                    <span className="text-xs text-neutral-500" data-id="element-223">
                      {new Date(story.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-display text-neutral-900 mb-2 leading-tight" data-id="element-224">
                    {story.title}
                  </h3>
                  <p className="text-neutral-600 mb-4 line-clamp-2" data-id="element-225">
                    {story.excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-sm text-neutral-500" data-id="element-226">
                    <span className="font-medium" data-id="element-227">{story.author}</span>
                    <span data-id="element-228">•</span>
                    <span data-id="element-229">{story.brand}</span>
                  </div>
                </div>
                <div className="flex flex-col gap-2 flex-shrink-0" data-id="element-230">
                  <button onClick={() => setSelectedStory(story)} className="px-6 py-2.5 border-2 rounded-lg hover:bg-opacity-10 transition-all font-medium text-sm" style={{
              borderColor: '#0289BB',
              color: '#0289BB',
              backgroundColor: 'transparent'
            }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.1)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} data-id="element-231">
                    Preview
                  </button>
                  <button onClick={() => handleRepublish(story)} className="px-6 py-2.5 text-white rounded-lg hover:shadow-md transition-all font-medium text-sm" style={{
              background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
            }} data-id="element-232">
                    Republish
                  </button>
                </div>
              </div>
            </div>)}
      </div>
      {/* Preview Modal */}
      {selectedStory && <StoryPreviewModal story={selectedStory} onClose={() => setSelectedStory(null)} onRepublish={handleRepublish} data-id="element-233" />}
      {/* Advanced Search Modal */}
      <AdvancedSearchModal isOpen={isAdvancedSearchOpen} onClose={() => setIsAdvancedSearchOpen(false)} searchQuery={searchQuery} onSearchQueryChange={setSearchQuery} languageFilter={languageFilter} onLanguageFilterChange={setLanguageFilter} brandFilter={brandFilter} onBrandFilterChange={setBrandFilter} dateFilter={dateFilter} onDateFilterChange={setDateFilter} categoryFilter={categoryFilter} onCategoryFilterChange={setCategoryFilter} regionFilter={regionFilter} onRegionFilterChange={setRegionFilter} onApply={handleApplyFilters} onClearAll={handleClearAllFilters} data-id="element-234" />
      {/* Republish Options Modal */}
      {republishOptionsStory && <RepublishOptionsModal story={republishOptionsStory} onClose={() => setRepublishOptionsStory(null)} onSelectApi={handleSelectApi} onSelectDownload={handleSelectDownload} data-id="element-235" />}
      {/* Download Content Modal */}
      {downloadContentStory && <DownloadContentModal story={downloadContentStory} onClose={() => setDownloadContentStory(null)} data-id="element-236" />}
    </div>;
}